module.exports = __webpack_public_path__ + "static/media/label-4.b3d1e1d1.svg";